import { Sparkles } from "lucide-react";

export function AtlasLauncher({ onClick, expanded }: { onClick: () => void; expanded: boolean }) {
  return (
    <button
      type="button"
      aria-label="Ask Markyt"
      title="Ask Markyt"
      aria-haspopup="dialog"
      aria-expanded={expanded}
      onClick={onClick}
      className="group fixed right-6 bottom-6 z-40 flex items-center rounded-full bg-navy/85 p-3 text-white shadow-md backdrop-blur transition-all hover:bg-navy hover:shadow-lg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan"
    >
      <Sparkles className="size-5 shrink-0 text-cyan" />
      {/* Label stays hidden until hover/focus so the launcher reads as a small, unobtrusive dot. */}
      <span className="max-w-0 overflow-hidden whitespace-nowrap pl-0 text-sm font-semibold opacity-0 transition-all duration-200 group-hover:max-w-[120px] group-hover:pl-2 group-hover:opacity-100 group-focus-visible:max-w-[120px] group-focus-visible:pl-2 group-focus-visible:opacity-100">
        Ask Markyt
      </span>
    </button>
  );
}
